export const TableText = ({
	title,
	classes,
	bold,
}: {
	title: string;
	classes?: string;
	bold?: boolean;
}) => {
	const classList = `table-font ${classes ? classes : ''}`;

	return <p className={classList}>{title}</p>;
};
